module.exports = __webpack_public_path__ + "img/button-icon-lisence-copy.b4c1a8d2.svg";